import { render, staticRenderFns } from "./ViewEvidence.vue?vue&type=template&id=2aba4d96&"
import script from "./ViewEvidence.vue?vue&type=script&lang=js&"
export * from "./ViewEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports